import Dns from '@mui/icons-material/Dns';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function DnsIcon(props: FixMe) {
  return <Dns {...props} />;
}

export default DnsIcon;
